import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
} from "@reduxjs/toolkit";

const searchBarSlice = createSlice({
  name: "searchbar",
  initialState: {
    value: "",
  },
  reducers: {
    onChangeSearchBar(state, action) {
      state.value = action.payload;
    },
  },
});

export const { onChangeSearchBar } = searchBarSlice.actions;

export default searchBarSlice.reducer;
